import { createContext, useContext, type PropsWithChildren, type ReactElement } from 'react';
import {
  useInspectionChartResultsInternal,
  type InspectionChartRuntime,
} from './useInspectionChartResultsInternal';

const InspectionChartRuntimeContext =
  createContext<InspectionChartRuntime | null>(null);

export function InspectionChartRuntimeProvider({
  children,
}: PropsWithChildren<{}>): ReactElement {
  const runtime = useInspectionChartResultsInternal();

  return (
    <InspectionChartRuntimeContext.Provider value={runtime}>
      {children}
    </InspectionChartRuntimeContext.Provider>
  );
}

export function useInspectionChartRuntime(): InspectionChartRuntime {
  const runtime = useContext(InspectionChartRuntimeContext);
  if (!runtime) {
    throw new Error(
      'useInspectionChartRuntime requires InspectionChartRuntimeProvider'
    );
  }
  return runtime;
}

export function useInspectionChartRuntimeOptional(): InspectionChartRuntime | null {
  return useContext(InspectionChartRuntimeContext);
}
